import { render, staticRenderFns } from "./AddPage.vue?vue&type=template&id=11997f7a&scoped=true&"
import script from "./AddPage.vue?vue&type=script&lang=js&"
export * from "./AddPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11997f7a",
  null
  
)

export default component.exports